import { render, staticRenderFns } from "./SectionResultatCalculette.vue?vue&type=template&id=20f5bc9e&scoped=true&"
import script from "./SectionResultatCalculette.vue?vue&type=script&lang=js&"
export * from "./SectionResultatCalculette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5bc9e",
  null
  
)

export default component.exports